import { SoldServiceAppDataModel } from '@user/store/opportunity'

import { SoldServicesFormModel } from '../typings'

type CustomFieldType = SoldServicesFormModel['customFields']

export function mergeCustomFieldValues(
  defaultValues: CustomFieldType,
  savedValues: CustomFieldType,
  appData: SoldServiceAppDataModel[],
): CustomFieldType {
  const hydratedValues = { ...defaultValues }

  for (const key in savedValues) {
    const field = appData.find((x) => x.id === key)
    if (!field) continue

    const savedValue = savedValues[key]

    if (field.type === 'Dropdown') {
      // make sure this option is still valid
      const idx = field.values.findIndex((x) => x.id === savedValue)
      if (idx === -1) continue
    }

    hydratedValues[key] = savedValue
  }

  return hydratedValues
}
